/**
 * The languages the app ships translations for. The values are the file names under `src/assets/i18n/`,
 * which is exactly what ngx-translate asks its loader for — so a value that is not in this list has no
 * file behind it and must never reach `TranslateService.use()`.
 */
export const APP_LANGUAGES = ['en', 'da'] as const;

export type AppLanguage = (typeof APP_LANGUAGES)[number];

/** What `setDefaultLang` is given: the language a key falls back to when the active one lacks it. */
export const DEFAULT_APP_LANGUAGE: AppLanguage = 'en';

export function resolveLanguage(stored: string | null | undefined, fallback: AppLanguage = 'da'): AppLanguage {
  const tag = stored?.trim().toLowerCase().split('-')[0];

  return APP_LANGUAGES.find((language) => language === tag) ?? fallback;
}
